// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.txt-field-body {
   border-style: none;
   overflow: hidden;
}

.c-validation {
   font-weight: normal;
   font-size: 0.8125em;
   line-height: 1.3em;
   margin-top: 5px;
   margin-left: 12px;
   margin-right: 10px;
   color: red;
}

.validate-error {
   border: 1.6px red dashed !important;
}

#holder, input {
   margin: 4px 10px 10px 12px !important;
   height: 200px;
   border: 1px #ccc dashed;
   background-color: #F6F7F8;
}

.file-upload {
   display: none;
   overflow: hidden;
   width: 0;
   height: 0;
}

.fa-upload {
   margin-right: 10px;
}

.btn-upload {
   width: 120px;
   margin-left: 10px;
   margin-right: 10px;
}

.tab-container {
   height: 215px;
   display: flex;
}

.doc-file {
   overflow: auto;
   width: 760px;
   height: 200px;
   margin-top: 3px;
}

.center {
   margin: auto;
   width: 60%;
   padding: 10px;
}

.object-file {
   height: 50px;
   width: 500px;
}

.document-upload {
   padding-top: 10px;
   text-overflow: ellipsis;
   white-space: nowrap;
   max-width: 100%;
   overflow: hidden;
   line-height: normal;
}
.field-group {
   margin-bottom: 10px;
}

.msg-center {
   line-height: 200px;
   height: 200px;
   text-align: center;
}

.msg-center p {
   line-height: 1.5;
   display: inline-block;
   vertical-align: middle;
   font-size: 14px;
}

.pointer-enable {
   pointer-events: auto;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-form/form-generate/field-type/upload/upload.component.css"],"names":[],"mappings":"AAAA;GACG,kBAAkB;GAClB,gBAAgB;AACnB;;AAEA;GACG,mBAAmB;GACnB,mBAAmB;GACnB,kBAAkB;GAClB,eAAe;GACf,iBAAiB;GACjB,kBAAkB;GAClB,UAAU;AACb;;AAEA;GACG,mCAAmC;AACtC;;AAEA;GACG,qCAAqC;GACrC,aAAa;GACb,uBAAuB;GACvB,yBAAyB;AAC5B;;AAEA;GACG,aAAa;GACb,gBAAgB;GAChB,QAAQ;GACR,SAAS;AACZ;;AAEA;GACG,kBAAkB;AACrB;;AAEA;GACG,YAAY;GACZ,iBAAiB;GACjB,kBAAkB;AACrB;;AAEA;GACG,aAAa;GACb,aAAa;AAChB;;AAEA;GACG,cAAc;GACd,YAAY;GACZ,aAAa;GACb,eAAe;AAClB;;AAEA;GACG,YAAY;GACZ,UAAU;GACV,aAAa;AAChB;;AAEA;GACG,YAAY;GACZ,YAAY;AACf;;AAEA;GACG,iBAAiB;GACjB,uBAAuB;GACvB,mBAAmB;GACnB,eAAe;GACf,gBAAgB;GAChB,mBAAmB;AACtB;AACA;GACG,mBAAmB;AACtB;;AAEA;GACG,kBAAkB;GAClB,aAAa;GACb,kBAAkB;AACrB;;AAEA;GACG,gBAAgB;GAChB,qBAAqB;GACrB,sBAAsB;GACtB,eAAe;AAClB;;AAEA;GACG,oBAAoB;AACvB","sourcesContent":[".txt-field-body {\n   border-style: none;\n   overflow: hidden;\n}\n\n.c-validation {\n   font-weight: normal;\n   font-size: 0.8125em;\n   line-height: 1.3em;\n   margin-top: 5px;\n   margin-left: 12px;\n   margin-right: 10px;\n   color: red;\n}\n\n.validate-error {\n   border: 1.6px red dashed !important;\n}\n\n#holder, input {\n   margin: 4px 10px 10px 12px !important;\n   height: 200px;\n   border: 1px #ccc dashed;\n   background-color: #F6F7F8;\n}\n\n.file-upload {\n   display: none;\n   overflow: hidden;\n   width: 0;\n   height: 0;\n}\n\n.fa-upload {\n   margin-right: 10px;\n}\n\n.btn-upload {\n   width: 120px;\n   margin-left: 10px;\n   margin-right: 10px;\n}\n\n.tab-container {\n   height: 215px;\n   display: flex;\n}\n\n.doc-file {\n   overflow: auto;\n   width: 760px;\n   height: 200px;\n   margin-top: 3px;\n}\n\n.center {\n   margin: auto;\n   width: 60%;\n   padding: 10px;\n}\n\n.object-file {\n   height: 50px;\n   width: 500px;\n}\n\n.document-upload {\n   padding-top: 10px;\n   text-overflow: ellipsis;\n   white-space: nowrap;\n   max-width: 100%;\n   overflow: hidden;\n   line-height: normal;\n}\n.field-group {\n   margin-bottom: 10px;\n}\n\n.msg-center {\n   line-height: 200px;\n   height: 200px;\n   text-align: center;\n}\n\n.msg-center p {\n   line-height: 1.5;\n   display: inline-block;\n   vertical-align: middle;\n   font-size: 14px;\n}\n\n.pointer-enable {\n   pointer-events: auto;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
